import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { StorageAdvancedSettingsComponent } from './storage-advanced-settings.component';
import { CustomModule } from 'angular/custom/custom.module';
import { FormsModule } from '@angular/forms';
import { StorageAdminPrismaCreditLimitCheckComponent } from './storage-admin-prisma-credit-limit-check.component';
import { CollapseModule } from 'ngx-bootstrap';
import { StorageAdminPrismaCreditLimitCheckFormComponent } from './storage-admin-prisma-credit-limit-check-form.component';
import { StoragePeriodTypePickerComponent } from 'angular/storage/storage-period-type-picker.component';

@NgModule({
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        CustomModule,
        FormsModule,
        CollapseModule
    ],
    exports: [
        StorageAdvancedSettingsComponent,
        StorageAdminPrismaCreditLimitCheckComponent
    ],
    declarations: [
        StorageAdvancedSettingsComponent,
        StorageAdminPrismaCreditLimitCheckComponent,
        StorageAdminPrismaCreditLimitCheckFormComponent,
        StoragePeriodTypePickerComponent
    ],
    entryComponents: [
        StorageAdvancedSettingsComponent,
        StorageAdminPrismaCreditLimitCheckComponent
    ]
})
export class StorageModule {}
